import { Flex, Img, Price, Text } from "flicket-ui";
import React, { useState } from "react";
import { CheckoutBNPLModal } from "~components/checkout/financial/checkout.BNPL.modal";
import { getAfterPayLocaleByCurrency } from "~config";
import { BNPLIntegration } from "~features/checkout/checkout.types";
import { BNPL_CONFIG } from "~features/checkout/constants";
import { IntegrationType } from "~graphql/sdk";
import { useBNPLPriceCalculation, useOrganization } from "~hooks";

interface BuyNowPayLaterProps {
  totalPrice: number;
  hasTicketSelected: boolean;
  bnplIntegration: Partial<BNPLIntegration>;
  showHiddenFees?: boolean;
  isSmallDisplay?: boolean;
}

const BuyNowPayLater = ({
  totalPrice,
  hasTicketSelected,
  bnplIntegration,
  isSmallDisplay = false,
}: BuyNowPayLaterProps) => {
  const [isOpen, setOpen] = useState(false);
  const { organization } = useOrganization();
  const { bnplPrice } = useBNPLPriceCalculation(totalPrice, bnplIntegration);
  const config = BNPL_CONFIG[bnplIntegration?.type];

  const showPrice = hasTicketSelected;

  return (
    <Flex
      onClick={() => setOpen(true)}
      alignItems={isSmallDisplay ? "flex-end" : "center"}
      justifyContent={isSmallDisplay ? "space-between" : "end"}
    >
      {bnplIntegration.type === IntegrationType.PaymentAfterpay ? (
        // @ts-expect-error - Afterpay placement component
        <afterpay-placement
          data-locale={getAfterPayLocaleByCurrency(organization.currency)}
          data-currency={organization?.currency}
          data-amount={totalPrice}
        >
          {/* @ts-expect-error - Afterpay placement component */}
        </afterpay-placement>
      ) : (
        <>
          <Text
            cursor="pointer"
            fontWeight="medium"
            display={isSmallDisplay ? "div" : "flex"}
            fontSize={isSmallDisplay ? 2 : 3}
            alignItems="center"
            color="N600"
            mr={1}
          >
            <Img
              marginLeft={isSmallDisplay ? 0 : 1}
              marginRight={1}
              width={80}
              display="block"
              src={`/static/${config?.icon}.svg`}
            />{" "}
            {config?.terms} {config?.period}ly interest free payments from{" "}
          </Text>

          <Text
            fontWeight="medium"
            fontSize={isSmallDisplay ? 2 : 3}
            // @ts-expect-error overriding theme styles
            marginBottom={isSmallDisplay ? "1px" : 0}
            lineHeight={"18px" as any}
            color="N800"
          >
            {showPrice ? <Price price={bnplPrice} /> : "-"}
          </Text>

          <CheckoutBNPLModal
            variant={bnplIntegration?.type}
            isOpen={isOpen}
            onClose={() => {
              setOpen(!isOpen);
            }}
          />
        </>
      )}
    </Flex>
  );
};

export default BuyNowPayLater;
